import React from 'react'
import { Link } from 'react-router-dom'
import { FaCog } from 'react-icons/fa'

import { LENDER_ROUTES } from '../../../_constants/routes'
import colors from '../../../_constants/colors'
import { S_BlockerModal } from './BlockerModal.styles'

export const PurchaseBlockerModal = () => {
  return (
    <S_BlockerModal>
      <FaCog className="blocker-modal-icon" color={colors.DEFAULT_SECONDARY} size={150} />

      <p className="blocker-modal-text">
        It looks like this purchase operation is taking a while.
        <br />
        <br />
        You will be notified when this schedule has been purchased. See
        <br />
        <Link to={LENDER_ROUTES.schedules_all}> Completed Schedules</Link>
        <br />
        to check the status of this schedule, which can also be accessed from the &quot;Invoices&quot; menu.
      </p>
    </S_BlockerModal>
  )
}
